module.exports = __webpack_public_path__ + "img/p-5.491c141e.jpg";